import { modes, CustomEvents } from '@powerplay/common';
import { CorePhases } from '../types';
import { PhaseManager } from './PhaseManager';
import { CameraStates } from '@powerplay/camera-system';
export class PhaseStartListManager extends PhaseManager {
    cameraManager;
    inputsManager;
    fpsManager;
    requestManager;
    constructor(cameraManager, inputsManager, fpsManager, requestManager) {
        super(cameraManager, inputsManager, fpsManager, requestManager);
        this.cameraManager = cameraManager;
        this.inputsManager = inputsManager;
        this.fpsManager = fpsManager;
        this.requestManager = requestManager;
        this.PHASE_NAME = 'START LIST';
        this.skippable = true;
        this.phaseNumber = CorePhases.startList;
    }
    startPhase() {
        super.startPhase();
        if (modes.isTutorial()) {
            super.finishPhase();
            return;
        }
        this.cameraManager.setState(CameraStates.table);
        this.cameraManager.playTween(true);
        window.dispatchEvent(new CustomEvent(CustomEvents.startStartListPhase));
    }
}
//# sourceMappingURL=PhaseStartListManager.js.map